<template lang="pug">
    #visao-geral-territorio-pssc
        BaseHeader(
            :titulo="$t('mensagens.pssc.telaVisaoGeralTerritorio.titulo')",
            :btnTexto="$t('mensagens.pssc.telaVisaoGeralTerritorio.btnVerTrilha')",
            :exibeBotao='true'
            @btnHeaderClicado="visualizarTrilha",
            :voltarPara='true'
        )
        #diagnostico-socioambiental-pssc
            section.diagnostico-socioambiental__resultado
                .diagnostico-socioambiental__resultado__header
                    h1 {{ informacoes_gerais.car ? informacoes_gerais.car : $t('mensagens.diagnosticoSocioambiental.titulo') }}

                .diagnostico-socioambiental__resultado__body
                    section
                        .mb-3
                            .informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.dataAnalise') }}
                            .informacoes-gerais.font_weight_bold {{ informacoes_gerais.dataAnalise ? informacoes_gerais.dataAnalise : '--' }}
                        div(
                            style='border-bottom: solid 1px var(--default-border-color)'
                        )

                        .mb-3(
                            v-if='informacoes_gerais !== null'
                            style='border-bottom: solid 1px var(--default-border-color)'
                        )
                            h3.font_weight_bold.informacoes-gerais_container(
                                slot='title',
                                style='color: var(--primary-font-color)'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.informacoesGerais') }}
                            .d-flex.flex-column
                                div.d-flex.flex-row
                                    .d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.localidade') }}
                                        span.font_weight_bold {{ informacoes_gerais.localidade ? informacoes_gerais.localidade : '--' }}
                                    .d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.areaImovel') }}
                                        span.font_weight_bold {{ informacoes_gerais.area_ha ? informacoes_gerais.area_ha : '--' }}
                                    .d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.situacaoCadastro') }}
                                        span.font_weight_bold {{ validaSituacao(informacoes_gerais.situacaoCadastro) }}
                                div.d-flex.flex-row
                                    div.d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.bioma') }}
                                        span.font_weight_bold {{ informacoes_gerais.bioma ? informacoes_gerais.bioma : '--' }}
                                    div.d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.situacaoReservaLegal') }}
                                        span.font_weight_bold {{ informacoes_gerais.situacaoReservaLegal ? informacoes_gerais.situacaoReservaLegal : '--' }}
                                    div.d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.moduloFiscal') }}
                                        span.font_weight_bold {{ informacoes_gerais.moduloFiscal ? informacoes_gerais.moduloFiscal : '--' }}
                                div.d-flex.flex-row
                                    div.d-flex.flex-column.informacoes-gerais-dado
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.aderiuPra') }}
                                        span.font_weight_bold {{ informacoes_gerais.aderiuPRA ? informacoes_gerais.aderiuPRA : '--' }}
                                    div.d-flex.flex-column.informacoes-gerais-dado.col2
                                        h4.informacoes-gerais {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.informacoesGerais.condicao') }}
                                        span.font_weight_bold {{ informacoes_gerais.condicao ? informacoes_gerais.condicao : '--' }}
                            p.text-right.text-info(
                                style='padding-top: 10px',
                                @click='openSiCARNewTab'
                            )
                                span.link-button(style='cursor: pointer') {{ $t('mensagens.diagnosticoSocioambiental.verDemonstrativoSicar') }}
                                    i.lyra-seguir-link.ml-3

                        div(
                            style='border-bottom: solid 1px var(--default-border-color); margin-top: -8px',
                            v-if='protocoloUtilizadoFormatado'
                        )
                            .d-flex.align-items-center(style='height: 40px')
                                b.font_weight_bold {{ $t('mensagens.diagnosticoSocioambiental.protocoloUtilizado') }}
                                i.mdi.mdi-information-outline(
                                    style='width: 25px; text-align: center;',
                                    slot='suffix',
                                    :title="$t('mensagens.blocoFiltros.infos.selecionarProtocoloParaDiagnostico')"
                                )
                            p(style='font-weight: 400; margin-bottom: 15px') {{ protocoloUtilizadoFormatado }}

                        div(
                            style='border-bottom: solid 1px var(--default-border-color)'
                        )
                            h3.font_weight_bold(style='margin-top: 16px') {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.analiseSocioambientalCar') }}

                            section(v-if='diagnosticoCar')
                                DiagnosticoSocioambiental.mb-3(
                                    v-if='refMapa',
                                    style='padding: 0; display: grid',
                                    :dadosConsulta='diagnosticoCar',
                                    :habilitar-opacidade='true',
                                    v-bind:cpfCnpj='null',
                                    v-bind:car='getCar()',
                                    @index-aberto='mostrarAreasDiagnosticoNoMapa',
                                    :fecharCollapses='true',
                                    :mapaLeaflet='refMapa',
                                    :habilitar-zoom-restricao='true',
                                    :habilitar-sinal-aviso='true',
                                    :indexCollapse='0'
                                )
                            section(
                                style='margin: 16px 0'
                                v-else
                            )
                                span(style='color: #7c7c7c') {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.analiseCarNaoRealizada') }}

                        div(
                            style='border-bottom: solid 1px var(--default-border-color)',
                            v-if='diagnosticoRepresentantes'
                        )
                            h3.font_weight_bold(style='margin-top: 16px') {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.proprietarios') }}

                            div(
                                v-for='representante in diagnosticoRepresentantes',
                                style='margin: 16px 0'
                            )
                                h4.informacoes-gerais.font_weight_bold(
                                    style='margin-bottom: -5px'
                                ) {{ representante.nome }}

                                DiagnosticoSocioambiental.mb-3(
                                    v-if='refMapa',
                                    style='padding: 0; display: grid',
                                    :dadosConsulta='representante',
                                    :habilitar-opacidade='true',
                                    v-bind:cpfCnpj='null',
                                    v-bind:car='null',
                                    @index-aberto='mostrarAreasDiagnosticoNoMapa',
                                    :fecharCollapses='true',
                                    :mapaLeaflet='refMapa',
                                    :habilitar-zoom-restricao='true',
                                    :habilitar-sinal-aviso='true',
                                    :indexCollapse='0'
                                )

                        div(
                            style='border-bottom: solid 1px var(--default-border-color)'
                        )
                            h3.font_weight_bold(style='margin-top: 16px') {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.codigoFlorestalBrasileiro.adequacaoAoCFB') }}

                            section(v-if='conformidadeCfb')
                                .cfb-dados
                                    h4.cfb-label {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.codigoFlorestalBrasileiro.deficitVegetacaoNativaReservaLegalHa') }}
                                    span.font_weight_bold {{ conformidadeCfb.deficitVegetacaoNativaReservaLegalHa }} Ha

                                .cfb-dados
                                    h4.cfb-label {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.codigoFlorestalBrasileiro.deficitVegetacaoNativaAppHa') }}
                                    span.font_weight_bold {{ conformidadeCfb.deficitVegetacaoNativaAppHa }} Ha

                                .cfb-dados
                                    h4.cfb-label {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.codigoFlorestalBrasileiro.desmatamentoAppApos220708Ha') }}
                                    span.font_weight_bold {{ conformidadeCfb.desmatamentoAppApos220708Ha }} Ha

                                .cfb-dados
                                    h4.cfb-label {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.codigoFlorestalBrasileiro.desmatamentoVegetacaoNativaApos220708Ha') }}
                                    span.font_weight_bold {{ conformidadeCfb.desmatamentoVegetacaoNativaApos220708Ha }} Ha

                            section(
                                style='margin: 16px 0'
                                v-else
                            )
                                span(style='color: #7c7c7c') {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.analiseCfbNaoRealizada')  }}

                .diagnostico-socioambiental__resultado__actions
                    BaseButton(
                        type='secondary',
                        size='default',
                        @click='extrairDadosProtocolo(); mostrarModalDetalharProtocolos.mostrar = true',
                        style='border-color: var(--primary); color: var(--primary); width: 100%;'
                    )
                        span {{ $t('mensagens.pssc.telaVisaoGeralTerritorio.botaoDetalharProtocolos') }}

            section.diagnostico-socioambiental__mapa.mapa.w-100.h-100
                mapa(
                    :showStatesLayers='true',
                    :mapLayersConfigs='layersMaps',
                    :mapConfig='mapConfig',
                    :height='"100%"',
                    :idMapa='"mapaDiagnosticoSocioambiental"',
                    ref='mapa',
                    :atualizarMapa='true',
                    :cluster='false',
                    :menuMaior='false'
                )

        ModalDetalharProtocolosPssc(
            :dados="dadosProtocoloUtilizadosAnalise",
            :show='mostrarModalDetalharProtocolos.mostrar',
            @closeDialog='mostrarModalDetalharProtocolos.mostrar = false'
        )
</template>

<script>
import {getEstiloGeometria} from '@/utils/mapa/mapa.estilos';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import BaseHeader from '@/components/BaseHeader';
import ModalDetalharProtocolosPssc from '@/components/pssc/ModalDetalharProtocolosPssc.vue';
import PSSCService from '@/services/PSSCService';
import {mapState} from 'vuex';

export default {
    name: 'index',

    components: {
        Mapa,
        DiagnosticoSocioambiental,
        BaseButton,
        BaseHeader,
        ModalDetalharProtocolosPssc
    },

    data() {
        return {
            territorio: this.$route?.params?.territorio,
            layersMaps: [],
            mapConfig: {
                controls: {
                    bufferControl: false,
                    ferramentasControl: false,
                    sentinelHubAccess: false,
                    buscarCarControl: false,
                    popupControl: false,
                    zoomControl: false,
                    camadasControl: false,
                    fullscreen: true,
                    drawControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            informacoes_gerais: {
                car: null,
                localidade: null,
                area_ha: null,
                situacaoCadastro: null,
                bioma: null,
                moduloFiscal: null,
                aderiuPRA: null,
                situacaoReservaLegal: null,
                condicao: null,
                geometria: null,
                dataAnalise: null
            },
            refMapa: null,
            protocoloUtilizado: '',
            protocoloUtilizadoFormatado: '',
            collapse: ['informacoes_gerais'],
            mostrarModalDetalharProtocolos: {
                mostrar: false
            },
            diagnosticoCar: null,
            diagnosticoRepresentantes: null,
            conformidadeCfb: null,
            dadosProtocoloUtilizadosAnalise: []
        };
    },

    mounted() {
        this.refMapa = this.$refs.mapa;
        this.buscarInformacoesGerais();
        this.buscarDadosDiagnosticoCar();
        this.buscarDadosDiagnosticoRepresentante();
        this.buscarDadosConformidadeCfb();
    },

    computed: {
        ...mapState(['usuarioLogado'])
    },

    methods: {
        extrairDadosProtocolo() {
        if (this.diagnosticoCar) {
            this.dadosProtocoloUtilizadosAnalise.push(...this.diagnosticoCar.diagnosticos.map(item => {
                return {
                    titulo: item.camada.nome,
                    fonte: item.camada.fonte
                };
            }));
        }

          this.diagnosticoRepresentantes.forEach(({diagnostico}) => {
            this.dadosProtocoloUtilizadosAnalise.push(...diagnostico.map(item => {
              return {
                titulo: item.camada.nome,
                fonte: item.camada.fonte
              };
            }));
          });

          this.dadosProtocoloUtilizadosAnalise = this.dadosProtocoloUtilizadosAnalise.filter((item, index, self) =>
              index === self.findIndex((t) => t.titulo === item.titulo)
          );
        },

        validaSituacao(situacao) {
            if (situacao) {
                switch (situacao) {
                    case 'AT':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.ativo');
                    case 'PE':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.pendente');
                    case 'SU':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.suspenso');
                    case 'CA':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.cancelado');
                    case 'RE':
                        return this.$t('mensagens.diagnosticoSocioambiental.situacoes.retificado');
                }
            } else {
                return '--';
            }
        },

        async buscarInformacoesGerais() {
            try {
                let {data} = await PSSCService.buscarInformacoesGeraisTerritorio(this.territorio);
                if (data) {
                    this.informacoes_gerais = {
                        car: data.car,
                        localidade: data.localidade,
                        area_ha: data.areaImovel,
                        situacaoCadastro: data.situacaoCadastro,
                        bioma: data.bioma,
                        moduloFiscal: data.moduloFiscal,
                        aderiuPRA: data.aderiuPRA,
                        situacaoReservaLegal: data.situacaoReservaLegal,
                        condicao: data.condicao,
                        geometria: data.geometria,
                        dataAnalise: data.dataAnalise
                    };
                }

                this.mostrarTerritorioNoMapa(data.geometria);
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisaoGeralTerritorio.erroBuscarInformacoesGerais')
                });
            }
        },

        async buscarDadosDiagnosticoCar() {
            try {
                var { data } = await PSSCService.buscarDadosDiagnosticoCar(this.territorio);
                if (data) {
                    if (!data.diagnostico) {
                        this.diagnosticoCar = null;
                    } else {
                        var dados = JSON.parse(data.diagnostico)[0];
                        for (let i = 0; i < dados.diagnosticos.length; i++) {
                            if (dados.diagnosticos[i].camada.codigo === 'DETER_AMAZONIA_LEGAL') {
                                dados.diagnosticos[i].camada.codigo = 'DETER_AMAZONIA';
                            }
                        }
                        this.diagnosticoCar = dados;
                    }
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisaoGeralTerritorio.erroBuscarDadosDiagnosticoCar')
                });
            }
        },

        async buscarDadosDiagnosticoRepresentante() {
            try {
                var { data } = await PSSCService.buscarDadosDiagnosticoRepresentante(this.territorio);
                if (data) {
                    this.diagnosticoRepresentantes = [];
                    data.itens.forEach(d => {
                        this.diagnosticoRepresentantes.push({
                          diagnostico: JSON.parse(d.diagnostico),
                          nome: d.nome
                        });
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisaoGeralTerritorio.erroBuscarDadosDiagnosticoRepresentante')
                });
            }
        },

        async buscarDadosConformidadeCfb() {
            try {
                var { data } = await PSSCService.buscarDadosConformidadeCfb(this.territorio);
                if (data) {
                    this.conformidadeCfb = data;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaVisaoGeralTerritorio.erroBuscarDadosConformidadeCfb')
                });
            }
        },

        mostrarTerritorioNoMapa(geometria, clearLayers) {
            if (clearLayers == null || clearLayers) {
                this.layersMaps = [];
            }
            const layersToAdd = [];

            layersToAdd.push({
                style: getEstiloGeometria('car'),
                name: 'Car',
                geoJson: geometria
            });
            this.$bus.$emit('mapa:show-buffer', true);

            layersToAdd.forEach(l => {
                this.layersMaps.push(l);
            });
        },

        openSiCARNewTab() {
            navigator.clipboard.writeText(this.informacoes_gerais.car);
            this.$notify.success({
                message:
                    'O número do CAR foi copiado para sua área de transferência, você está sendo direcionado para o site do SICAR'
            });

            setTimeout(() => {
                window.open('https://www.car.gov.br/#/consultar', '_blank');
            }, 3000);
        },

        getCar() {
            if (this.informacoes_gerais.car && this.informacoes_gerais.car !== '') {
                const car = this.informacoes_gerais.car.toUpperCase();
                if (car.startsWith('PA')) {
                    return this.informacoes_gerais.car;
                }
            }
            return null;
        },

        mostrarAreasDiagnosticoNoMapa(
            restricao,
            indexCollapse,
            indexRestricao
        ) {
            this.mostrarTerritorioNoMapa(this.informacoes_gerais.geometria);
            if (indexRestricao === '' || indexRestricao === null) return;

            const diagnostico = this.diagnosticoCar.diagnosticos[indexRestricao];

            const opacidade =
                diagnostico.camada.opacidade >= 0.0
                    ? diagnostico.camada.opacidade / 200
                    : 0.5;

            const areas = diagnostico.resultados.filter(
                resultado => resultado.geometria || resultado.geometry
            );

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;
                this.layersMaps.push({
                    name: `AreaDiagnostico_red_${indexCollapse}_${indexRestricao}_${index}`,
                    group: `grupo-restricoes-${indexCollapse}-${indexRestricao}`,
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    geoJson: geometria
                });

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico_${index}_${indexCollapse}`,
                    icon: pin,
                    geoJson: centroidFromGeoJSON.get(geometria)
                });
            });
        },

        visualizarTrilha() {
            window.open(window.location.origin + '#/pssc/trilha/' + this.territorio + '/visao-trilha/' + this.usuarioLogado.idKeyCloack, '_blank');
        }
    }
};
</script>

<style lang="scss">
#visao-geral-territorio-pssc {
    height: 100%;
    width: 100%;
}

.informacoes-gerais_container {
    margin: 16px 0;
}

.informacoes-gerais-dado {
    height: fit-content;
    width: 33%;
    padding: 8px 8px 8px 0px;
    font-size: 13px !important;
}

.informacoes-gerais {
    font-size: 13px !important;
    height: 16px !important;
    font-weight: 400 !important;
    margin-bottom: 4px;
}

.cfb-dados {
    height: fit-content;
    width: 100%;
    margin: 16px 0;
    font-size: 13px !important;
}
.cfb-label {
    font-size: 13px !important;
    font-weight: 400 !important;
    margin-bottom: 4px;
}

@media (max-width: 1430px) {
    .informacoes-gerais-dado {
        height: fit-content;
        width: 31%;
        padding: 8px 5px 8px 0px;
    }
}

#diagnostico-socioambiental-pssc {
    padding: 20px;
    width: 100%;
    height: calc(100vh - 152px);
    display: flex;

    .diagnostico-socioambiental__resultado {
        @include scroll-bar();
        background-color: var(--white);
        border-radius: 5px 0 0 5px;
        padding: 20px;
        overflow-y: auto;
        width: 65%;

        .diagnostico-socioambiental__resultado__header {
            height: auto;
            margin-bottom: 16px;
            display: flex;
            align-items: center;

            h1 {
                font: 500 18px Roboto, sans-serif;
            }
        }

        .diagnostico-socioambiental__resultado__body {
            height: calc(100% - 110px);
            overflow-y: auto;

            p {
                font: 500 14px Roboto, sans-serif;
            }

            .container-restricao p {
                font: 400 13px Roboto, sans-serif;
                color: var(--primary-font-color) !important;
                line-height: 1.77;
            }
        }

        .diagnostico-socioambiental__resultado__actions {
            display: flex;
            justify-content: space-between;
            margin-top: 1.2rem;
        }
    }

    .diagnostico-socioambiental__mapa {
        width: 55%;
    }
}

label {
    font: 14px/150% Roboto, sans-serif;
    margin-bottom: 0.5rem !important;
}

.outline-button {
    color: #00413c !important;
    font: 500 14px/143% Roboto, sans-serif !important;
    border: 1px solid #00413c !important;
    margin-bottom: 10px !important;
}

.primary-button {
    margin-top: 16px;
    margin-bottom: 32px !important;
    font: 500 14px/143% Roboto, sans-serif !important;
}

.border-error input {
    border-color: var(--danger) !important;
}

#mapaDiagnosticoSocioambiental {
    border-radius: 0 5px 5px 0;
}

.el-collapse-item__content {
    color: var(--primary-font-color) !important;
}

.el-collapse-item__wrap {
    border-bottom: solid 1px var(--default-border-color) !important;
}

.font_weight_bold {
    font-weight: 500 !important;
}
</style>
